import React from "react";
import { Button } from "antd";
import { Link } from "react-router-dom";
import notFoundImage from "../../images/404.jpg";
import "./index.css";
import { t } from "i18next";
const NotFound = () => {
  return (
    <div className="not-found-container">
      <img className="not-found-image" src={notFoundImage} alt="notFound" />
      <p className="not-found-message">{t("notFoundPage")}</p>
      <Link to="/">
        <Button
          className="custom-button not-found-button"
          size="large"
          type="primary"
        >
          {t("home")}
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
